import OSS from "ali-oss"
const common = {
  async attachUpload(ossParams, file, reback) {
    const client = new OSS({
      endpoint: ossParams.endpoint,
      accessKeyId: ossParams.accessKey,
      accessKeySecret: ossParams.secretKey,
      bucket: ossParams.bucketName,
    });
    const storeAs = this.getFileName(file.file.name);
    const res = await client.put(storeAs, file.file, {
      mime: "application/octet-stream",
    });
    const info = {
      name: file.file.name,
      fileSize: this.getFileSize(file.file.size),
      url: `https://${ossParams.bucketName}.${ossParams.endpoint.slice(8, 100)}/${storeAs}`,
      fileType: this.getFileType(file.file.name),
      createTime: new Date(),
      id: file.file.uid,
    };
    if (reback) {
      reback(info, file);
    }
    return Promise.resolve(info);
  },
  getFileName(type) {
    const date = new Date().getTime();
    return date + this.getString20() + "." + this.getFileType(type);
  },
  getFileType(filename) {
    const arr = filename.split(".");
    return arr[arr.length - 1];
  },
  getFileSize(limit) {
    var size = "";
    if (limit < 0.1 * 1024) {
      // 如果小于0.1KB转化成B
      size = limit.toFixed(2) + "B";
    } else if (limit < 0.1 * 1024 * 1024) {
      // 如果小于0.1MB转化成KB
      size = (limit / 1024).toFixed(2) + "KB";
    } else if (limit < 0.1 * 1024 * 1024 * 1024) {
      // 如果小于0.1GB转化成MB
      size = (limit / (1024 * 1024)).toFixed(2) + "MB";
    } else {
      // 其他转化成GB
      size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
    }
    var sizestr = size + "";
    var len = sizestr.indexOf(".");
    var dec = sizestr.substr(len + 1, 2);
    if (dec === "00") {
      // 当小数点后为00时 去掉小数部分
      return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
    }
    return sizestr;
  },
  getString20() {
    var data = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
    ];
    var result = "";
    for (var i = 0; i < 20; i++) {
      var r = Math.floor(Math.random() * 62); // 取得0-62间的随机数，目的是以此当下标取数组data里的值！
      result += data[r]; // 输出20次随机数的同时，让rrr加20次，就是20位的随机字符串了。
    }
    return result;
  },
};
export default common;
